import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import Nav from '../components/Nav.jsx'
import Button from '../components/Button.jsx'
import TeamCarousel from '../components/TeamCarousel.jsx'

const Landing = () => {

  const team = {
    items: [
      {
        img: '/images/coralie.webp',
        user: "Coralie",
        text: "Créatrice et gérante de l'institut depuis février 2017. Spécialiste du massage et de la prise en charge globale du bien-être, Coralie s'est également expertisée dans l'épilation durable (laser & thermolyse) et les soins minceur."
      },
      {
        img: '/images/Gabrielle.jpeg',
        user: "Gabrielle",
        text: "Esthéticienne, Gabrielle est spécialisée dans l'art du massage grâce à sa formation Titre Spa. Passionnée par l'univers du bien-être et du lâcher-prise, elle met son expertise et sa douceur au service de vos rituels de soins tout en réalisant l’ensemble de nos prestations esthétiques."
      },
      {
        img: '/images/Solene.jpeg',
        user: "Solene",
        text: "Apprentie esthéticienne, Solène a rejoint l'équipe pour parfaire sa formation et développer son expertise. Douce et appliquée, elle réalise une sélection de nos soins sous l'œil bienveillant de l'équipe pour vous offrir un pur moment de relaxation."
      },
      {
        img: '/images/leonie.webp',
        user: "Léonie",
        text: "Esthéticienne au sein de l’institut depuis septembre 2023. Passionnée et minutieuse, Léonie est spécialisée dans la pose de vernis semi-permanent tout en réalisant avec soin l’ensemble de nos prestations esthétiques et relaxantes.."
      },
      {
        img: '/images/Clara.jpeg',
        user: "Clara",
        text: "Esthéticienne, Clara est actuellement en formation pour l'obtention du Titre Spa afin d'approfondir son expertise des rituels du corps et du lâcher-prise. Douce et attentionnée, elle met son savoir-faire en massages et sa maîtrise des soins esthétiques du quotidien au service de votre beauté et de votre bien-être."
      }
    ]
  };


  const book =
  {
    items: [
      {
        text: "Réserver",
        class: "bg-black text-white font-biryani text-sm py-2 px-4 rounded mt-3 smd:mr-3 xl:mt-10 xl:mr-8",
        link: "https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/352672"

      },
    ],
  }

  const knowMore =
  {
    items: [
      {
        text: "En savoir plus",
        class: "bg-white text-black font-biryani text-sm py-2 px-4 rounded mt-3 mb-5 xl:mt-10",
        link: "#"

      },
    ],
  }

  const whiteBook =
  {
    items: [
      {
        text: "Réserver",
        class: "bg-white text-black font-biryani text-sm py-2 px-1 sm:py-2 sm:px-4 rounded mt-3 mb-5 xl:mt-5 border-2 border-black ml-3 slg:mt-8 smd:ml-8 xl:ml-14",
        link: "https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190085"

      },
    ],
  }

  const prestation =
  {
    items: [
      {
        text: "Voir tout",
        class: "bg-black text-white font-biryani text-sm py-2 px-1 sm:py-2 sm:px-4 rounded mt-3 mb-5 xl:mt-5 border-2 border-black ml-3 slg:mt-8 smd:ml-8 xl:ml-14",
        link: "https://www.kalendes.com/instantbienetrecoralie/#/link/PAGE/RESERVE"

      },
    ],
  }

  

  const scrollToElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (element !== null) {
      element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  };


  return (
    <div className="overflow-x-hidden">
      <Nav scroll={scrollToElement} />
    <header className="relative bg-cover bg-center h-screen" style={{ backgroundImage: "url('/images/spa.png')" }}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4">
        <h1 className='text-4xl md:text-6xl font-bold font-crimson-text mb-4'>Découvrez notre SPA</h1>
        <p className='font-biryani text-lg md:text-xl max-w-2xl mb-8'>
            Découvrez notre Espace Spa Privatif
            Profitez de 1h30 de détente absolue à deux dans un espace 100% privatif. Hammam, sauna et bain balnéo double sont à votre disposition pour un pur moment de lâcher-prise.
            Le petit plus : Prolongez l'expérience en associant votre séance spa à l'un de nos massages ou soins du visage.
        </p>
        <a href="https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/352672" target="_blank" rel="noopener noreferrer" className="bg-white text-black font-biryani font-bold text-sm py-3 px-6 rounded-lg hover:bg-gray-200 transition-colors">
            Réserver mon accès Spa
        </a>
      </div>
    </header>

    <section id="soins" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-crimson-text text-black">Nos Soins Experts</h2>
          <p className="font-biryani text-gray-600 text-lg mt-4 max-w-3xl mx-auto">
              En plus de nos prestations esthétiques du quotidien (épilations traditionnelles, soins du visage, beauté des mains et des pieds, minceur), Instant Bien-être met à votre disposition des expertises ciblées et haute technologie :
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="p-6 shadow-lg rounded-lg hover:shadow-xl transition-shadow">
              <a target='_blank' rel="noopener noreferrer" href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/562921'>
              <img className='w-full h-48 object-cover rounded-md mb-4' src='/images/soins_visage.jpeg' alt='Soin Aqua faciale' />
                <h3 className='font-poppins text-xl font-semibold text-gray-800'> Soins Visage Bio</h3>
                <p>Rituels sur-mesure & cosmétique certifiée bio Estime & Sens</p>
            </a>
          </div>
          <div className="p-6 shadow-lg rounded-lg hover:shadow-xl transition-shadow">
              <a target='_blank' rel="noopener noreferrer" href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190080'>
              <img className='w-full h-48 object-cover rounded-md mb-4' src='/images/epilation.jpeg' alt='Épilation durable' />
              <h3 className='font-poppins text-xl font-semibold text-gray-800'>Épilation Durable</h3>
                <p>Laser & thermolyse pour une peau douce au quotidien</p>
            </a>
          </div>
          <div className="p-6 shadow-lg rounded-lg hover:shadow-xl transition-shadow">
              <a target='_blank' rel="noopener noreferrer" href='https://www.kalendes.com/site/instantbienetrecoralie/link/ARTICLE/2952973'>
              <img className='w-full h-48 object-cover rounded-md mb-4' src='/images/head_spa.jpeg' alt='Soin enfants' />
                <h3 className='font-poppins text-xl font-semibold text-gray-800'>Head Spa</h3>
                <p>Rituel détente du cuir chevelu & lâcher-prise absolu</p>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section id="massage" className="py-20 bg-[#FDF5F1]">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="md:w-1/2">
            <img className='w-full h-auto object-cover rounded-lg' src='/images/coralie_massageweb.png' alt='Massage' />
          </div>
          <div className="md:w-1/2 text-left">
            <h2 className="text-3xl md:text-4xl font-bold font-crimson-text text-black mb-4">Massages du Monde</h2>
            <p className="font-biryani text-gray-600 text-lg mb-6">
                Spécialisée dans le massage depuis notre ouverture, nous vous proposons différents massages à venir découvrir. Nous nous formons régulièrement afin de vous apporter de la nouveauté. Nos massages sont aussi proposés en duo ou dans des rituels de soin.
            </p>
            <div className="font-biryani text-gray-700 space-y-2 mb-6">
              <p><span className="font-bold">30 min</span> - 35€</p>
              <p><span className="font-bold">50 min</span> - 55€</p>
              <p><span className="font-bold">80 min</span> - 85€</p>
            </div>
            <a href="https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190085" target="_blank" rel="noopener noreferrer" className="bg-black text-white font-biryani font-bold text-sm py-3 px-6 rounded-lg hover:bg-gray-800 transition-colors">
              Découvrir nos Massages
            </a>
          </div>
        </div>
      </div>
    </section>

      {/*<h2 id='team' className='text-black text-lg mt-14 font-bold font-crimson-text slg:text-3xl smd:text-2xl xl:text-4xl text-center xl:mt-32'>Notre équipe</h2>*/}
      <TeamCarousel content={team} />

      <footer id="contact" className="bg-[#FDF5F1] text-gray-800 pt-16 pb-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center text-center">
            <div className="w-full lg:w-1/3 px-4 mb-8">
              <h3 className="font-poppins font-semibold text-lg mb-4">Horaires</h3>
              <p className="font-biryani">
                Lundi - Vendredi: 9h - 19h<br />
                Samedi: 9h - 18h
              </p>
            </div>
            <div className="w-full lg:w-1/3 px-4 mb-8">
              <h3 className="font-poppins font-semibold text-lg mb-4">Contact</h3>
              <p className="font-biryani mb-2">
                <a href="tel:+33237645723" className="hover:text-black"><FontAwesomeIcon icon={faPhone} className="mr-2" />02 37 64 57 23</a>
              </p>
              <p className="font-biryani">
                <a href="mailto:instantbienetretremblay@gmail.com" className="hover:text-black"><FontAwesomeIcon icon={faEnvelope} className="mr-2" />instantbienetretremblay@gmail.com</a>
              </p>
            </div>
            <div className="w-full lg:w-1/3 px-4 mb-8">
              <h3 className="font-poppins font-semibold text-lg mb-4">Suivez-nous</h3>
              <div className="flex justify-center gap-6 text-gray-800">
                <a href="#" className="text-2xl hover:text-black"><i className="fab fa-facebook-f"></i></a>
                <a href="#" className="text-2xl hover:text-black"><i className="fab fa-instagram"></i></a>
                <a href="#" className="text-2xl hover:text-black"><i className="fab fa-tiktok"></i></a>
              </div>
            </div>
          </div>
          <div className="text-center mt-8 border-t border-gray-300 pt-8">
            <p className="font-biryani text-sm text-gray-600">
              &copy; {new Date().getFullYear()} Instant Bien Être. Tous droits réservés. | <a href='/Mention-légales' target='_blank' className='underline hover:text-black'>Mentions Légales</a>
            </p>
            <p className="font-biryani text-xs text-gray-500 mt-2">
              8 Rue du Dr Taugourdeau, 28170 Tremblay-les-Villages
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Landing